import { render, staticRenderFns } from "./CoastToCoastActivities.vue?vue&type=template&id=c0881a9c&scoped=true&"
import script from "./CoastToCoastActivities.vue?vue&type=script&lang=js&"
export * from "./CoastToCoastActivities.vue?vue&type=script&lang=js&"
import style0 from "./CoastToCoastActivities.vue?vue&type=style&index=0&id=c0881a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0881a9c",
  null
  
)

export default component.exports